import React from 'react';
import { wrapReactionHook } from "../../hooks";
export var StatusFilter = wrapReactionHook(function (props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement("div", null, "StatusFilter", children);
});